import {createContext, FC, ReactNode, useContext, useMemo, useState} from "react";
import {
    BentoPersona,
    BentoPersonaId,
    getBentoPersonaById,
    readStoredBentoPersonaId,
    storeBentoPersonaId
} from "./bentoPersona";

interface BentoPersonaContextValue {
    persona: BentoPersona;
    setPersonaId: (id: BentoPersonaId) => void;
}

const BentoPersonaContext = createContext<BentoPersonaContextValue | null>(null);

interface BentoPersonaProviderProps {
    children: ReactNode;
}

export const BentoPersonaProvider: FC<BentoPersonaProviderProps> = ({children}) => {
    const [personaId, setPersonaIdState] = useState<BentoPersonaId>(
        readStoredBentoPersonaId
    );

    const setPersonaId = (id: BentoPersonaId): void => {
        setPersonaIdState(id);
        storeBentoPersonaId(id);
    };

    const value = useMemo(
        () => ({
            persona: getBentoPersonaById(personaId),
            setPersonaId
        }),
        [personaId]
    );

    return (
        <BentoPersonaContext.Provider value={value}>
            {children}
        </BentoPersonaContext.Provider>
    );
};

export const useBentoPersona = (): BentoPersonaContextValue => {
    const context = useContext(BentoPersonaContext);
    if (!context) {
        throw new Error("useBentoPersona must be used within BentoPersonaProvider");
    }
    return context;
};
